import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { useChartZoom } from '@/components/Charts/components/ChartZoom';
import { LstHistoricalChart } from '@/components/Charts/LstHistorical';
import { GraphFact } from '@/components/Charts/types';

import { NoPlotData } from '../NoPlotData';
import { getLstGraphData } from './utils';

export const LstGraphTile = ({
  historicData,
  forecastData,
  benchmarkData,
}: {
  historicData: GraphFact[] | null | undefined;
  forecastData: GraphFact[] | null | undefined;
  benchmarkData: GraphFact[] | null | undefined;
}) => {
  const { t } = useTranslation();
  const { zoom, setZoom } = useChartZoom();

  if (!historicData?.length) {
    return <NoPlotData />;
  }

  return (
    <Stack
      spacing={6}
      data-testid='lst-graph-tile'
      className='items-center justify-center px-1 py-6 lg:items-start lg:p-6 lg:pl-1'
    >
      <ChartHeading
        heading={t('shared.ncaDetail.details.landSurfaceTemperature.labels.historicalGraphHeadline')}
        popover={{
          title: t('shared.ncaDetail.details.landSurfaceTemperature.explainers.historicalGraph.title'),
          body: t('shared.ncaDetail.details.landSurfaceTemperature.explainers.historicalGraph.body'),
        }}
        className='w-full px-6 sm:px-0'
        zoom={zoom}
        setZoom={setZoom}
      />
      <LstHistoricalChart
        data={getLstGraphData(historicData, forecastData, benchmarkData)}
        zoom={zoom}
        setZoom={setZoom}
      />
    </Stack>
  );
};
